import axios from 'axios';
import { GoogleUserInfo } from './types';
import { AppViewService } from './AppViewService';

export const AppViewServiceImpl: AppViewService = {
  getUser: async (email: string): Promise<GoogleUserInfo> => {
    try {
      // In a real implementation, we would fetch user data from our backend
      // But for now, we'll construct a minimal user object based on the email
      const nameParts = email.split('@')[0].split('.');

      const userInfo: GoogleUserInfo = {
        id: '',
        email: email,
        verified_email: true,
        name: nameParts
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(' '),
        given_name:
          nameParts[0]?.charAt(0).toUpperCase() + nameParts[0]?.slice(1) || '',
        family_name:
          nameParts[1]?.charAt(0).toUpperCase() + nameParts[1]?.slice(1) || '',
        picture: `https://ui-avatars.com/api/?name=${encodeURIComponent(nameParts.join(' '))}&background=random`,
        locale: 'en',
      };

      return userInfo;
    } catch (error) {
      console.error('Error getting user:', error);
      throw error;
    }
  },
};
